import React, { useState } from 'react';
import PT from 'prop-types';
import cn from 'classnames';

import Button from 'Components/Admin/Button';
import CloseSVG from 'Components/Admin/assets/CloseSVG';
import useCheckIsMobile from 'Shared/hooks/useCheckIsMobile';
import TriangleIcon from 'Components/Admin/TriangleIcon/TriangleIcon';

const SubmitPanel = ({ tab = 'General', onSave, onCancel }) => {
  const isMobile = useCheckIsMobile();
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleIsCollapsed = () => setIsCollapsed(prevState => !prevState);

  return (
    <div
      className={cn('submit-panel', { 'submit-panel_collapsed': isCollapsed })}
      data-testid="submit-panel"
    >
      {!isMobile && <button className="submit-panel__close" onClick={onCancel}><CloseSVG /></button>}
      {
        isMobile && (
          <TriangleIcon
            className="submit-panel__collapse"
            direction={isCollapsed ? 'up' : 'down'}
            onClick={toggleIsCollapsed}
          />
        )
      }
      <div className="submit-panel__info">
        <p>You has made changes in <b>{tab}</b> tab.</p>
        <p>Please save it if necessary.</p>
      </div>
      <div className="submit-panel__btn-group">
        <Button className="submit-panel__btn submit-panel__btn_cancel" variant="simple" onClick={onCancel}>
          Cancel
        </Button>
        <Button className="submit-panel__btn" variant="primary" onClick={onSave} dataTestId="submit-form">
          Save Changes
        </Button>
      </div>
    </div>
  );
};

SubmitPanel.propTypes = {
  tab: PT.string,
  onSave: PT.func,
  onClose: PT.func,
};

export default SubmitPanel;
